/**
 * @file msn模块的路径，组件，菜单，权限相关配置
 * @author  fangsimin
 * @date    2020-02-09 17:49:50
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:39:03
 */

const env = process.env;
const module = env['MODULE_CMP_MOBILE'];

// 路径，组件菜单配置
// 路径：必须包含key
// 组件：必须包含title
const config = [
    {
        id: '1',
        path: '/',
        key: 'home',
        component: resolve => require(['@/modules/mobile/pages/home'], resolve)
    },
    {
        id: '2',
        path: '/solutions',
        key: 'solutions',
        component: resolve => require(['@/modules/mobile/pages/solutions'], resolve)
    },
    {
        id: '3',
        path: '/partners',
        key: 'partners',
        component: resolve => require(['@/modules/mobile/pages/partners'], resolve)
    },
    {
        id: '4',
        path: '/cases',
        key: 'cases',
        component: resolve => require(['@/modules/mobile/pages/cases'], resolve)
    },
    {
        id: '5',
        path: '/about',
        key: 'about',
        component: resolve => require(['@/modules/mobile/pages/about'], resolve)
    },
    {
        id: '6',
        path: '/case-detail',
        key: 'case-detail',
        component: resolve => require(['@/modules/mobile/pages/case-detail'], resolve)
    },
    {
        id: '7',
        path: '/partner-detail',
        key: 'partner-detail',
        component: resolve => require(['@/modules/mobile/pages/partner-detail'], resolve)
    }
];

/**
 * 获取真正的路径
 * @param  {string} path 路径
 * @param  {boolean} hasModule 是否包含模块
 * @return {string}
 */
function getModulePath(path, hasModule = true) {
    // console.log(hasModule, env['BASE_URI'], module, path);
    return path
        ? (hasModule ? [env['BASE_URI'], module, path]
            : [env['BASE_URI'], path]).join('/').replace('//', '/')
        : '/';
}

/**
 * 通过前面的config配置，获取menu和路径配置
 *
 * @param  {Object} config [description]
 * @return {Object}        [description]
 */
function getConfig(config) {
    let routerConfig = [];
    let path = {};
    let menu = config.reduce((ret, item) => {
        if (item['key']) {
            if (item['title']) {
                // item['title'] = this.$i18n.t(item['title']);
                if (item['children']) {
                    item['children'] = item['children'].reduce((ret, child) => {
                        if (child['key']) {
                            if (child['title']) {
                                // child['title'] = this.$i18n.t(child['title']);
                                ret.push(child);
                            }
                            let keys = [item['key'], child['key']];
                            path[keys.join('_')] = getModulePath(keys.join('/'));
                            if (child['component']) {
                                // let componentPath = ['@/modules', module, 'pages', ...keys].join('/');
                                // console.log(componentPath);
                                routerConfig.push({
                                    path: path[keys.join('_')],
                                    component: child['component']
                                });
                            }
                        }
                        return ret;
                    }, []);
                }
                ret.push(item);
            }
            path[item['key']] = getModulePath(item['key']);
            if (item['component']) {
                routerConfig.push({
                    path: path[item['key']],
                    component: item['component']
                });
            }
        }
        return ret;
    }, []);
    return {
        menu,
        path,
        routes: routerConfig
    };
}

export default getConfig(config);



// WEBPACK FOOTER //
// ./src/modules/mobile/constants/pathConfig.js